/* eslint-disable no-unused-expressions */
import React from 'react';
import { ListWrapperV2 } from './ListWrapperV2';
import { getFiltersFromURL } from '../../utils/util';

const PreSelectedFilterList = () => {
  const preSelectedFilters = getFiltersFromURL();
  return (
    <div data-testid="GiftCardsPreFilteredList">
      <ListWrapperV2 preSelectedFilters={preSelectedFilters} />
    </div>
  );
};

PreSelectedFilterList.displayName = 'PreSelectedFilterList';

export { PreSelectedFilterList };
